<template>
  <div class="textarea" data-input>
    <label v-if="label" :for="id" class="textarea__label form-label">
      {{ label }}
      <sup v-if="!required" class="textarea__label__small info-label">
        {{ t('form-optional') }}
      </sup>
    </label>

    <div class="textarea__container">
      <textarea
        :id="id"
        :name="name"
        :required="required"
        :placeholder="placeholder"
        :value="modelValue"
        v-bind="$attrs"
        class="textarea__field"
        @input="$emit('update:modelValue', $event.target.value)"
      >
      </textarea>
      <div class="textarea__lines">
        <div
          v-for="line in lines.length < 5 ? 5 : lines"
          :key="line"
          class="textarea__line"
        >
          <span class="textarea__line__content">{{ line }}</span>
        </div>
      </div>
    </div>
    <p class="input__error">{{ t('form-invalid') }}</p>
  </div>
</template>

<script setup lang="ts">
import { useChromeStore } from '@/stores/chrome'
import { computed } from 'vue'

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  required: {
    type: Boolean,
    default: true,
  },
  name: {
    type: String,
    default: '',
  },
  id: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  modelValue: {
    type: String,
    default: '',
  },
})

defineEmits(['update:modelValue'])

const lines = computed(() => props.modelValue.split('\n'))
const { t } = useChromeStore()
</script>

<style lang="scss" scoped>
.textarea {
  color: var(--c-foreground);
}

.textarea__label {
  display: block;
  margin-bottom: 1.5rem;
}

.textarea__label__small {
  margin: 0 0 0.5rem 1.5rem;
  opacity: 0.5;
}

.textarea__container {
  position: relative;
}

.textarea__field {
  @include get-all-space;

  overflow: hidden;
  padding: 0 1rem;
  color: var(--c-foreground);
  font-size: 1.6rem;
  line-height: 3rem;
  background: transparent;
  border: 0;
  box-shadow: none;
  outline: none;
  resize: none;
}

.textarea__lines {
  overflow: hidden;
  padding: 0 0 3rem;
  border: 1px solid var(--c-foreground);
  border-radius: 8px;

  .has-error & {
    border: 3px solid var(--c-foreground);
  }
}

.textarea__line {
  height: 3rem;
  min-height: 3rem;
  border-bottom: 1px dashed var(--c-foreground);
}

.textarea__line__content {
  opacity: 0;
}
</style>
